module.exports = __webpack_public_path__ + "static/media/financepic4@3x.69bcf753.png";